import { useTheme } from '@emotion/react'
import { GuardedExternalLink } from '../GuardedExternalLink'
import { ResponsiveCSSObject } from '@/styles/types'
import { LINKS } from './constants'
import { Button } from './Button'

import * as externalRoutes from '@/routes/external'
const ALL_ROUTES = externalRoutes as any

type Props = {
  sx?: ResponsiveCSSObject
  onClickButton?: () => void
}

export function MenuDesktop({ sx, onClickButton }: Props) {
  const theme = useTheme()
  return (
    <div
      css={theme.mq({
        flexFlow: 'row nowrap',
        ...sx,
      })}
    >
      {LINKS.map(({ children, onClick, guarded, ...rest }, index) => {
        if (guarded) {
          const content = children({})

          const routeKey = (rest as any).to
          const routeObject = ALL_ROUTES[routeKey]
          const href = routeObject?.pathname

          return (
            <GuardedExternalLink
              key={index}
              href={href}
              onClick={() => {
                if (onClick) onClick()
                if (onClickButton) onClickButton()
              }}
              sx={{
                ...rest?.sx,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: '1.25rem',
              }}
            >
              {content}
            </GuardedExternalLink>
          )
        }

        const content = children

        return (
          <Button
            key={index}
            onClick={() => {
              if (onClick) onClick()
              if (onClickButton) onClickButton()
            }}
            {...rest}
          >
            {content}
          </Button>
        )
      })}
    </div>
  )
}
